import { useSearchUnitActivations, useSearchUnitActivationsCount } from '@apps-common/apis/portal/unit-activations'
import { UnitActivationHeader } from '@apps-common/apps/portal/pages/units/pages/activations/components'
import { buildTableKeys } from '@apps-common/apps/portal/pages/units/pages/activations/components/activations-table/table-keys'
import { useActivationUpdates } from '@apps-common/apps/portal/pages/units/pages/activations/hooks'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { UnitActivationStatus, UnitActivationStatusDescription } from '@apps-common/config/unit-activation'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { useServiceRequestFilterStore, useUnitActivationFilter } from '@apps-common/stores'

const containerId = 'activations-table-container'

export const UnitActivationsTableView: React.FC = () => {
  const navigation = useNavigation()
  const { type } = useServiceRequestFilterStore()
  const filter = useUnitActivationFilter()

  const {
    isLoading: countIsLoading,
    isError: countIsError,
    data: countData
  } = useSearchUnitActivationsCount({
    config: {
      enabled: type === 'activations'
    },
    model: filter
  })

  const {
    isLoading: activationsLoading,
    isFetching: activationsFetching,
    isError: activationsError,
    // isRefetching: isRefetchingActivations,
    data: activations,
    refetch: refetchActivations
  } = useSearchUnitActivations({
    config: {
      enabled: type === 'activations'
    },
    model: filter
  })

  const allLoading = activationsLoading || activationsFetching || activationsError || countIsLoading || countIsError

  useActivationUpdates(containerId, activationsLoading, allLoading, activations || [])

  const getCountExtraText = () => {
    if (filter.statusVal in UnitActivationStatusDescription) {
      return UnitActivationStatusDescription[filter.statusVal as UnitActivationStatus]
    }

    return ''
  }
  const countLoading = countIsLoading || countIsError
  const loading = activationsLoading || activationsError || countLoading

  return (
    <>
      <UnitActivationHeader navigation={navigation}>
        <div className='flex items-center justify-between gap-[5px]'>
          <PageResultsCount loading={countLoading} count={countData} extraText={getCountExtraText()} />
          <PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />
        </div>
      </UnitActivationHeader>
      <LayoutContainer id='unit-activations-table-container'>
        <LayoutPadding topPadding='pt-[120px] md:pt-[20px]'>
          <Table
            loading={loading}
            loadingSkeletonHeight='leading-[36px]'
            placeholderSkeletonHeight='leading-[36px]'
            pagination={{
              loading: countLoading,
              count: countData?.resultCount,
              skip: filter.skip,
              take: filter.take,
              onSkipChanged: (value) => filter.setSkip(value),
              onTakeChanged: (value) => filter.setTake(value)
            }}
            keys={buildTableKeys(navigation)}
            data={activations}
            onSkipChanged={(value) => filter.setSkip(value)}
            onTakeChanged={(value) => filter.setTake(value)}
          />
        </LayoutPadding>
      </LayoutContainer>
    </>
  )
}
